import { TERMS_OF_USE_AND_PRIVACY_POLICY_EFFECTIVE_DATE } from '../../../util/helpers';
export var SymbioticSettings = {
    common: {
        name: 'Symbiotic',
        effectiveDate: TERMS_OF_USE_AND_PRIVACY_POLICY_EFFECTIVE_DATE
    }
};
